const kycSourcedReportTypes = {
	/** ***************** FETCH KYC SOURCED REPORT DETAILS START *********************** */
	GET_KYC_SOURCED_REPORT_START: 'getKYCSourcedReportStart',
	GET_KYC_SOURCED_REPORT_SUCCESS: 'getKYCSourcedReportSuccess',
	GET_KYC_SOURCED_REPORT_FAILURE: 'getKYCSourcedReportFailure',
	GET_KYC_SOURCED_REPORT_RESPONSE_RESET_START: 'getKYCSourcedReportResponseResetStart',
	GET_KYC_SOURCED_REPORT_RESPONSE_CHANGED: 'getKYCSourcedReportResponseResetChanged',
	/** ***************** FETCH KYC SOURCED REPORT DETAILS END *********************** */
};
export default kycSourcedReportTypes;
